const touchFix = {
    bind: function (el, binding, vnode) {
        el.addEventListener('touchmove', (e) => {
            // 滚动容器阻止冒泡，因此是否prevent由当前函数决定
            e.stopPropagation();
            let scrollEl = e.currentTarget;
            // 判定当前滚动容器是否可以滚动
            if (scrollEl.scrollHeight <= scrollEl.offsetHeight) {
                // 不能滚动的时候依然需要阻止滚动穿透
                e.preventDefault();
            }
        }, false);
    }
};
export default touchFix;